module.exports = __webpack_public_path__ + "static/media/sportone-logo.8bdfff2f.jpg";